import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '1 — ¿Cómo recibo el MegaPack después de comprar?',
  answer: 'Al completar la compra recibís un email con el acceso a todos los PDFs en menos de 5 minutos. Descargás todo de una vez y lo tenés para siempre en tu dispositivo. Sin suscripciones. Sin vencimiento.'
}, {
  question: '2 — ¿Sirve para profes particulares o solo para clubes?',
  answer: 'Sirve para ambos. El 60% de nuestros profes son independientes (particulares, dueños de academia, freelance). El 40% trabaja en clubes o instituciones deportivas. El sistema funciona en los dos contextos.'
}, {
  question: '3 — ¿Es editable? ¿Puedo modificarlo?',
  answer: 'El MegaPack es un PDF estructurado listo para usar. Podés imprimir las clases, llevarlas a la cancha en el celular o tablet. No es editable en el sentido de modificar el diseño, pero podés agregar notas en papel o en apps de anotación en PDF.'
}, {
  question: '4 — ¿Los 6 bonos están en las dos ofertas?',
  answer: 'Sí. Los 6 bonos estratégicos están incluidos en el MegaPack Padel Listo y en el Combo Completo con Pádel Pro Business. En las dos opciones. Sin costo extra. Sin condición.'
}, {
  question: '5 — ¿Sirve si soy profe nuevo con poca experiencia enseñando?',
  answer: 'Es exactamente para eso. El sistema Scan & Play está diseñado para que el profe lea la clase en 3 minutos antes de entrar. No necesitás experiencia previa organizando clases. Solo seguís la estructura y enseñás.'
}, {
  question: '6 — ¿Sirve para alumnos de todas las edades?',
  answer: 'El MegaPack está organizado por nivel de juego (8va/7ma / 6ta/5ta / 4ta/3ra / 2da/1ra), no por edad. Funciona igual para un principiante de 15 años que para uno de 50. Lo que importa es el nivel de juego, no la edad.'
}, {
  question: '7 — ¿Qué pasa si tengo alumnos de distintos niveles al mismo tiempo?',
  answer: 'Para eso existe el Bono 4 (Clases con Niveles Mezclados). 6 rotaciones listas para 3 y 4 alumnos de distintos niveles. El sistema 2-1-1 y los Roles Fijos hacen que nadie se aburra y todos mejoren en la misma hora de clase.'
}, {
  question: '8 — ¿Qué diferencia tiene el MegaPack con otros materiales de pádel?',
  answer: 'La mayoría del material de pádel son videos de YouTube, drills sueltos sin progresión o libros de técnica sin estructura de clase. El MegaPack es diferente porque: está organizado por el sistema de categorías argentino, cada clase tiene objetivo → técnica → juego → evaluación, tiene progresión real de nivel a nivel, incluye gestión, negocio y retención de alumnos, está pensado para el profe que da clases todos los días y necesita algo listo, no algo que tenga que adaptar.'
}, {
  question: '9 — ¿Por qué elegir el Combo Completo y no el estándar?',
  answer: 'El MegaPack Padel Listo resuelve el problema de las clases. El Pádel Pro Business resuelve el problema del negocio. Si querés dar mejores clases: el MegaPack alcanza. Si querés dar mejores clases Y ganar más dinero de forma predecible: necesitás el Combo Completo. El 70% de nuestros compradores elige el Combo.'
}, {
  question: '10 — ¿Tiene garantía real?',
  answer: 'Sí. 7 días con devolución del 100% sin preguntas. Escribís a soporteprofepack@gmail.com dentro de los 7 días de la compra y te devolvemos todo. Sin formularios. Sin demora. Sin drama.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-158">
      <div className="max-w-3xl mx-auto" data-id="element-159">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-160">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 mb-10" data-id="element-161">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#00B4D8] bg-[#000d1a]' : 'border-[#00B4D8]/20 bg-black'}`} data-id="element-162">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-163">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-164">
                  ❓ {faq.question}
                </span>
                <span className={`text-[#00B4D8] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-165">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-166">
                  <div className="h-px bg-[#00B4D8]/20 mb-4" data-id="element-167" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-168">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}